export default "__VITE_ASSET__CLG6qMMF__"